//
//
//
//
//
//
//
//
//

export default {
    props: {
        flex: {
            type: Boolean,
            default: true
        },
        step: {
            type: [String, Number],
            default: 1
        },
        name: {
            type: [String, Number],
            default: '步骤'
        }
    }    
}
